import Subscriptions from '@/app/subscriptions/Subscriptions'

export default [
	{
		path: '/backend/subscriptions',
		name: 'backend.subscriptions',
		component: Subscriptions,
	},
]
